import { useTranslation } from "react-i18next";
import { Box, IconButton, List, ListItem, ListItemButton, Modal, Typography } from "@mui/material";
import CloseButtonIcon from "assets/icons/Close";
import ImageIcon from "@mui/icons-material/Image";

interface IGlobalNotifiImagesModalProps {
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  previewImagesArray: string[];
  setPreviewImage: (imagePath: File | string) => void;
}

const GlobalNotificationsImagesModal = ({
  isModalOpen,
  setIsModalOpen,
  previewImagesArray,
  setPreviewImage,
}: IGlobalNotifiImagesModalProps) => {
  const { t } = useTranslation();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    if (files && files.length > 0) {
      setPreviewImage(files[0]);
    }
  };

  return (
    <Modal
      open={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      aria-labelledby="modal-notifi-preview-title"
      aria-describedby="modal-notifi-preview-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
          padding: "32px 24px 24px 24px",
          bgcolor: "#FFFFFF",
          boxShadow: "0 0 4px 0 rgba(165, 163, 174, 0.3);",
          width: "90%",
          maxWidth: "680px",
          height: "auto",
          maxHeight: "90dvh",
          overflowY: "auto",
        }}
      >
        <IconButton
          sx={{ position: "absolute", top: 16, right: 16, width: 32, height: 32 }}
          aria-label="modal close button"
          onClick={() => setIsModalOpen(false)}
        >
          <CloseButtonIcon />
        </IconButton>
        <Typography
          id="modal-title"
          variant="h2"
          sx={{
            marginBottom: "14px",
            fontSize: "24px",
            fontWeight: 400,
            color: "#2E263D",
            textAlign: "center",
          }}
        >
          {t("selectPicture")}
        </Typography>
        <List
          dense
          sx={{
            width: "100%",
            maxHeight: "436px",
            display: "flex",
            gap: "20px",
            flexWrap: "wrap",
            overflowY: "auto",
          }}
        >
          {previewImagesArray.map((value) => {
            return (
              <ListItem key={value} disablePadding sx={{ width: "calc((100% - 20px) / 2)", height: "200px" }}>
                <ListItemButton sx={{ width: "100%", height: "200px" }} onClick={() => setPreviewImage(value)}>
                  <img
                    src={value}
                    alt="preview-picture"
                    style={{ display: "block", width: "100%", height: "100%", objectFit: "contain" }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
        <Box
          component="label"
          htmlFor="preview-image-upload"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "24px",
            width: "auto",
            height: "40px",
            border: "1px dashed #C9D0D8",
            borderRadius: "8px",
            backgroundColor: "#F6F7FB",
            textAlign: "center",
            cursor: "pointer",
          }}
          id="icon-input"
        >
          <input
            type="file"
            id="preview-image-upload"
            name="preview-image-upload"
            onChange={handleInputChange}
            hidden
          />
          <ImageIcon sx={{ width: "24px", height: "24px", color: "#6D6777" }} />
          <Typography
            sx={{
              fontFamily: "var(--cygreRegular), sans-serif",
              color: "#2E263D",
              fontSize: "14px",
              lineHeight: 1,
            }}
          >
            {t("uploadFromDevice")}
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default GlobalNotificationsImagesModal;
